module.exports = __webpack_public_path__ + "img/certification.db0f26f3.png";